window.UIkit = require("uikit");
const Icons = require("uikit/dist/js/uikit-icons-custom");
UIkit.use(Icons);
import "./../../custom/uikit-gulfstream.less";
